"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getFingerprint;
exports.FINGERPRINT_KEY = void 0;

var _fingerprintjs = _interopRequireDefault(require("@fingerprintjs/fingerprintjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var FINGERPRINT_KEY = 'fingerprint';
exports.FINGERPRINT_KEY = FINGERPRINT_KEY;

function getFingerprint() {
  return _getFingerprint.apply(this, arguments);
}

function _getFingerprint() {
  _getFingerprint = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var cachedFingerprint, fp, fingerprint;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cachedFingerprint = localStorage.getItem('fingerprint');

            if (!cachedFingerprint) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", cachedFingerprint);

          case 3:
            _context.next = 5;
            return _fingerprintjs["default"].load();

          case 5:
            fp = _context.sent;
            _context.next = 8;
            return fp.get();

          case 8:
            fingerprint = _context.sent.visitorId;
            localStorage.setItem(FINGERPRINT_KEY, fingerprint);
            return _context.abrupt("return", fingerprint);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getFingerprint.apply(this, arguments);
}